define((require) => {
    "use strict";

    const {defaults, extend, pluck} = require("underscore");
    const Matrix                    = require("shared/vendor/Matrix");
    const Transformable             = require("ui/experience/widgets/transformations/Transformable");

    const DEFAULT_CONTROL_OPTIONS = {
        rotateScale: false,
        edgeTranslate: false
    };

    /**
     * An TElement object is a wrapper of dom element which extends from the abstract class {@link Transformable}
     *
     * @param domElem   raw dom element
     * @param data  controls for this element
     * @constructor
     */
    function TElement(domElem, data) {
        this.domElem = domElem;
        this.data = data;
        this.startMatrix = new Matrix();
        this.endMatrix = new Matrix();

        this.border = 2;

        this.data.controls = defaults(this.data.controls || {}, DEFAULT_CONTROL_OPTIONS);

        this.setOrigin(0, 0);
    }

    // extends from transformable abstract class
    TElement.prototype = extend(new Transformable(), {

        draw() {
            // apply a clone of the matrix to the element with x and y
            // rounded off to nearest int. avoids blurred text in webkit.
            const appliedMatrix = this.matrix.clone();
            appliedMatrix.x = Math.round(this.matrix.x);
            appliedMatrix.y = Math.round(this.matrix.y);

            this._setStyle("transform", appliedMatrix.toString());
        },

        getZIndex() {
            return this.domElem.style.zIndex;
        },

        setOrigin(x, y) {
            this._setStyle("transformOrigin", `${x} ${y}`);
        },

        /**
         * Safely apply css style to the element.
         * @param {String} styleName    The css property
         * @param {String} styleValue   The css value
         */
        _setStyle(styleName, styleValue) {
            if (!this.domElem) {
                return;
            }

            this.domElem.style[styleName] = styleValue;
        },

        getControlsConf() {
            return this.data.controls;
        },

        setTransparency(opacity) {
            this.domElem.style.opacity = opacity;
        },

        /**
         * Get the width of this element
         * @returns {int} the width
         */
        getWidth() {
            return this.domElem.offsetWidth || this.domElem.clientWidth;
        },

        /**
         * Get the height of this element
         * @returns {int} the height
         */
        getHeight() {
            return this.domElem.offsetHeight || this.domElem.clientHeight;
        },

        /**
         * Get the matrix for current target
         * @returns {Matrix} an matrix object
         */
        getMatrix() {
            return Matrix.createFromDom(this.domElem);
        },

        getMatrixWithParentOffset() {
            const matrix = this.getMatrix();
            if (this.data.parentTransform) {
                matrix.x += this.data.parentTransform.x;
                matrix.y += this.data.parentTransform.y;
            }
            return matrix;
        },

        _getAxis(axis) {
            const coords = this.getCornerCoordinates();
            return pluck(coords, axis);
        },

        setAttr(attr, value) {
            this.domElem.setAttribute(attr, value);
        }
    });

    return TElement;
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/transformations/TElement.js